import './registrer.css';
import '../footer/about.css';

import React, {
  useEffect,
  useState,
} from 'react';

import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

import SocialLoginRegistrer from './coursespublicpage/SocialLoginRegistrer';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faUser,
  faEnvelope,
  faLock,
  faCheckCircle,
  faTimesCircle,
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';

export const Registrer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [username, setUsername] =
    useState('');

  const [email, setEmail] =
    useState('');

  const [password, setPassword] =
    useState('');

  const [repeatpass, setRepeatpass] =
    useState('');

  const [successMessage, setSuccessMessage] =
    useState('');

  const [errorMessage, setErrorMessage] =
    useState('');

  const [isLoading, setIsLoading] =
    useState(false);

  const [
    passwordStrength,
    setPasswordStrength,
  ] = useState({
    score: 0,
    text: '',
    color: '',
  });

  const [
    showPassword,
    setShowPassword,
  ] = useState(false);

  const [
    showRepeatPassword,
    setShowRepeatPassword,
  ] = useState(false);

  const apiUrl =
    process.env.REACT_APP_API_URL;

  // ==========================================
  // ONBOARDING
  // ==========================================

  const onboardingAnswersFromState =
    location.state?.onboardingAnswers;

  let onboardingAnswersFromStorage = null;

  try {
    const rawOnboardingAnswers =
      localStorage.getItem(
        'onboardingAnswers'
      );

    onboardingAnswersFromStorage =
      rawOnboardingAnswers
        ? JSON.parse(rawOnboardingAnswers)
        : null;

  } catch (error) {
    onboardingAnswersFromStorage = null;
  }

  const onboardingAnswers =
    onboardingAnswersFromState &&
    typeof onboardingAnswersFromState ===
      'object'
      ? onboardingAnswersFromState
      : onboardingAnswersFromStorage;

  // ==========================================
  // MESAJ EROARE INREGISTRARE
  // ==========================================

  const getRegistrationErrorMessage = (
    responseStatus,
    apiMessage
  ) => {
    if (
      responseStatus === 409 ||
      /deja utilizat|deja exista/i.test(
        apiMessage || ''
      )
    ) {
      return (
        'Exista deja un cont cu aceasta ' +
        'adresa de email. Te rugam sa te ' +
        'autentifici sau sa folosesti alt email.'
      );
    }

    return (
      apiMessage ||
      'A aparut o eroare la crearea contului.'
    );
  };

  // ==========================================
  // ERORI DIN URL
  // ==========================================

  useEffect(() => {
    const error =
      searchParams.get('error');

    if (!error) {
      return undefined;
    }

    setErrorMessage(
      decodeURIComponent(error)
    );

    const timer = setTimeout(() => {
      setErrorMessage('');

      navigate(
        '/registrer',
        { replace: true }
      );
    }, 8000);

    return () =>
      clearTimeout(timer);

  }, [navigate, searchParams]);

  // ==========================================
  // VALIDARE EMAIL
  // ==========================================

  const validateEmail = (
    emailValue
  ) => {
    const normalizedEmail =
      emailValue
        .trim()
        .toLowerCase();

    if (!normalizedEmail) {
      return {
        valid: false,
        message:
          'Te rugam sa introduci adresa de email.',
      };
    }

    // Lungimea maxima standard
    if (normalizedEmail.length > 254) {
      return {
        valid: false,
        message:
          'Adresa de email este prea lunga.',
      };
    }

    // Structura generala
    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

    if (
      !emailRegex.test(
        normalizedEmail
      )
    ) {
      return {
        valid: false,
        message:
          'Adresa de email este invalida.',
      };
    }

    const parts =
      normalizedEmail.split('@');

    if (parts.length !== 2) {
      return {
        valid: false,
        message:
          'Adresa de email este invalida.',
      };
    }

    const [
      localPart,
      domain,
    ] = parts;

    if (
      !localPart ||
      !domain ||
      localPart.length > 64
    ) {
      return {
        valid: false,
        message:
          'Adresa de email este invalida.',
      };
    }

    // ========================================
    // GMAIL - TYPOS FRECVENTE
    // ========================================

    const gmailTypos = [
      'gmail.co',
      'gmail.con',
      'gmail.cmo',
      'gmail.om',
      'gmail.cm',
      'gmail.comm',
      'gmai.com',
      'gmial.com',
      'gamil.com',
      'gnail.com',
      'gmaill.com',
      'gmal.com',
    ];

    if (
      gmailTypos.includes(domain)
    ) {
      return {
        valid: false,
        message:
          'Adresa pare scrisa gresit. Ai vrut sa folosesti @gmail.com?',
      };
    }

    // ========================================
    // YAHOO - TYPOS FRECVENTE
    // ========================================

    const yahooTypos = [
      'yahoo.co',
      'yahoo.con',
      'yahoo.cmo',
      'yaho.com',
      'yaoo.com',
      'yahooo.com',
    ];

    if (
      yahooTypos.includes(domain)
    ) {
      return {
        valid: false,
        message:
          'Adresa pare scrisa gresit. Verifica domeniul Yahoo.',
      };
    }

    // ========================================
    // OUTLOOK / HOTMAIL - TYPOS
    // ========================================

    const microsoftTypos = [
      'outlook.co',
      'outlook.con',
      'outlook.cmo',
      'outlok.com',
      'outloo.com',
      'hotmai.com',
      'hotmail.co',
      'hotmail.con',
      'hotmail.cmo',
    ];

    if (
      microsoftTypos.includes(domain)
    ) {
      return {
        valid: false,
        message:
          'Adresa pare scrisa gresit. Verifica domeniul emailului.',
      };
    }

    return {
      valid: true,
      email: normalizedEmail,
    };
  };

  // ==========================================
  // PUTERE PAROLA
  // ==========================================

  const calculatePasswordStrength = (
    pass
  ) => {
    let score = 0;

    if (pass.length >= 8) {
      score++;
    }

    if (/[A-Z]/.test(pass)) {
      score++;
    }

    if (/[a-z]/.test(pass)) {
      score++;
    }

    if (/[0-9]/.test(pass)) {
      score++;
    }

    if (
      /[!@#$%^&*(),.?":{}|<>]/.test(
        pass
      )
    ) {
      score++;
    }

    if (score <= 2) {
      return {
        score,
        text: 'Slaba',
        color: '#ff4444',
      };
    }

    if (score === 3) {
      return {
        score,
        text: 'Medie',
        color: '#ffaa00',
      };
    }

    if (score === 4) {
      return {
        score,
        text: 'Buna',
        color: '#00cc88',
      };
    }

    return {
      score,
      text: 'Excelenta',
      color: '#00aa44',
    };
  };

  // ==========================================
  // VALIDARE PAROLA
  // ==========================================

  const validatePassword = (
    passwordValue
  ) => {
    const minLength = 8;

    const hasUpperCase =
      /[A-Z]/.test(passwordValue);

    const hasLowerCase =
      /[a-z]/.test(passwordValue);

    const hasNumber =
      /[0-9]/.test(passwordValue);

    const hasSpecialChar =
      /[!@#$%^&*(),.?":{}|<>]/.test(
        passwordValue
      );

    if (
      passwordValue.length <
      minLength
    ) {
      return (
        'Parola trebuie sa aiba ' +
        'cel putin 8 caractere.'
      );
    }

    if (!hasUpperCase) {
      return (
        'Parola trebuie sa contina ' +
        'cel putin o litera mare.'
      );
    }

    if (!hasLowerCase) {
      return (
        'Parola trebuie sa contina ' +
        'cel putin o litera mica.'
      );
    }

    if (!hasNumber) {
      return (
        'Parola trebuie sa contina ' +
        'cel putin un numar.'
      );
    }

    if (!hasSpecialChar) {
      return (
        'Parola trebuie sa contina ' +
        'cel putin un caracter special.'
      );
    }

    return '';
  };

  // ==========================================
  // SUBMIT
  // ==========================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    setErrorMessage('');
    setSuccessMessage('');

    // ========================================
    // NUME
    // ========================================

    const normalizedUsername =
      username.trim();

    if (!normalizedUsername) {
      setErrorMessage(
        'Te rugam sa introduci numele.'
      );

      return;
    }

    // ========================================
    // EMAIL
    // ========================================

    const emailValidation =
      validateEmail(email);

    if (!emailValidation.valid) {
      setErrorMessage(
        emailValidation.message
      );

      return;
    }

    // ========================================
    // PAROLA
    // ========================================

    const passwordError =
      validatePassword(password);

    if (passwordError) {
      setErrorMessage(
        passwordError
      );

      return;
    }

    // ========================================
    // CONFIRMARE PAROLA
    // ========================================

    if (
      password !== repeatpass
    ) {
      setErrorMessage(
        'Parolele nu se potrivesc.'
      );

      return;
    }

    setIsLoading(true);

    const userData = {
      username:
        normalizedUsername,

      email:
        emailValidation.email,

      password,

      onboardingAnswers,
    };

    try {
      const response =
        await fetch(
          `${apiUrl}/accounts`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',
            },

            body:
              JSON.stringify(userData),

            credentials:
              'include',
          }
        );

      let data = {};

      try {
        data =
          await response.json();
      } catch (jsonError) {
        data = {};
      }

      if (!response.ok) {
        throw new Error(
          getRegistrationErrorMessage(
            response.status,
            data?.message
          )
        );
      }

      // ======================================
      // CONT CREAT
      // ======================================

      setUsername('');
      setEmail('');
      setPassword('');
      setRepeatpass('');

      setPasswordStrength({
        score: 0,
        text: '',
        color: '',
      });

      setSuccessMessage(
        data?.message ||
        (
          'Contul a fost creat cu succes! ' +
          'Te rugam sa verifici adresa de ' +
          'email pentru a confirma contul.'
        )
      );

      setErrorMessage('');

      try {
        localStorage.removeItem(
          'onboardingAnswers'
        );
      } catch (error) {
        // Ignoram eroarea de storage.
      }

    } catch (error) {
      console.error(
        'Registration error:',
        error
      );

      setErrorMessage(
        error.message ||
        (
          'A aparut o eroare. ' +
          'Te rugam sa incerci din nou.'
        )
      );

    } finally {
      setIsLoading(false);
    }
  };

  // ==========================================
  // RETURN
  // ==========================================

  return (
    <div className="general-container-footer-info-ab">

      <div className="info-footer-container-ab">

        <div className="registrer-wrapper">

          {/* SOCIAL LOGIN */}

          <div className="options-connect-registrer">
            <SocialLoginRegistrer />
          </div>

          {/* DIVIDER */}

          <div className="divider-sau">
            <span>
              SAU
            </span>
          </div>

          {/* FORMULAR */}

          <form
            className="registrer-form"
            onSubmit={handleSubmit}
          >

            <h2 className="registrer-title">
              Creeaza cont cu e-mail
            </h2>

            {/* NUME */}

            <div className="input-group-reg">

              <FontAwesomeIcon
                icon={faUser}
                className="input-icon-reg"
              />

              <input
                type="text"
                id="username"
                name="username"
                className="input-reg with-icon"
                placeholder="Nume si prenume"
                value={username}
                onChange={(e) =>
                  setUsername(
                    e.target.value
                  )
                }
                autoComplete="name"
                required
              />

            </div>

            {/* EMAIL */}

            <div className="input-group-reg">

              <FontAwesomeIcon
                icon={faEnvelope}
                className="input-icon-reg"
              />

              <input
                type="email"
                id="email"
                name="email"
                value={email}
                className="input-reg with-icon"
                placeholder="Email"
                onChange={(e) =>
                  setEmail(
                    e.target.value
                  )
                }
                autoComplete="email"
                inputMode="email"
                maxLength={254}
                required
              />

            </div>

            {/* PAROLA */}

            <div
              className="input-group-reg"
              style={{
                position: 'relative',
              }}
            >

              <FontAwesomeIcon
                icon={faLock}
                className="input-icon-reg"
              />

              <input
                type={
                  showPassword
                    ? 'text'
                    : 'password'
                }
                id="password"
                name="password"
                value={password}
                className="input-reg with-icon"
                placeholder="Parola"
                style={{
                  paddingRight: '45px',
                }}
                autoComplete="new-password"
                onChange={(e) => {
                  const value =
                    e.target.value;

                  setPassword(value);

                  if (value) {
                    setPasswordStrength(
                      calculatePasswordStrength(
                        value
                      )
                    );
                  } else {
                    setPasswordStrength({
                      score: 0,
                      text: '',
                      color: '',
                    });
                  }
                }}
                required
              />

              <FontAwesomeIcon
                icon={
                  showPassword
                    ? faEyeSlash
                    : faEye
                }
                className="toggle-password-icon-reg"
                onClick={() =>
                  setShowPassword(
                    (current) =>
                      !current
                  )
                }
              />

            </div>

            {/* PUTERE PAROLA */}

            {password && (
              <div className="password-strength-indicator">

                <div className="strength-bar">

                  <div
                    className="strength-fill"
                    style={{
                      width:
                        `${
                          (
                            passwordStrength.score /
                            5
                          ) * 100
                        }%`,

                      backgroundColor:
                        passwordStrength.color,
                    }}
                  />

                </div>

                <span
                  className="strength-text"
                  style={{
                    color:
                      passwordStrength.color,
                  }}
                >
                  Putere parola:{' '}
                  {passwordStrength.text}
                </span>

              </div>
            )}

            {/* REPETA PAROLA */}

            <div
              className="input-group-reg"
              style={{
                position: 'relative',
              }}
            >

              <FontAwesomeIcon
                icon={faLock}
                className="input-icon-reg"
              />

              <input
                type={
                  showRepeatPassword
                    ? 'text'
                    : 'password'
                }
                id="repeatpass"
                name="repeatpass"
                value={repeatpass}
                className="input-reg with-icon"
                placeholder="Reintrodu parola"
                style={{
                  paddingRight: '45px',
                }}
                autoComplete="new-password"
                onChange={(e) =>
                  setRepeatpass(
                    e.target.value
                  )
                }
                required
              />

              <FontAwesomeIcon
                icon={
                  showRepeatPassword
                    ? faEyeSlash
                    : faEye
                }
                className="toggle-password-icon-reg"
                onClick={() =>
                  setShowRepeatPassword(
                    (current) =>
                      !current
                  )
                }
              />

            </div>

            {/* EROARE */}

            {errorMessage && (
              <div className="message-box error-message-box">

                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className="message-icon"
                />

                {errorMessage}

              </div>
            )}

            {/* SUCCESS */}

            {successMessage && (
              <div className="message-box success-message-box">

                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="message-icon"
                />

                {successMessage}

              </div>
            )}

            {/* SUBMIT */}

            <button
              type="submit"
              className="input-reg-submit"
              disabled={isLoading}
            >
              {isLoading
                ? 'Se inregistreaza...'
                : 'Creeaza cont'}
            </button>

          </form>

          {/* LOGIN */}

          <div className="redirect-registrer">

            <span className="redirect-reg-text">
              Ai deja cont?
            </span>

            <Link
              to="/login"
              className="redirect-reg-link"
            >
              <b>
                Conecteaza-te!
              </b>
            </Link>

          </div>

          {/* TERMENI */}

          <div className="redirect-registrer">

            <span className="redirect-reg-text-terms">

              Prin inregistrare, sunteti de acord cu

              <Link
                to="/Termeni"
                className="redirect-reg-terms"
              >
                <span>
                  {' '}
                  termenii si conditiile de utilizare
                </span>
              </Link>

            </span>

          </div>

        </div>

      </div>

    </div>
  );
};